
import { defineComponent } from "vue";

import Modal from "./Modal.vue";

export default defineComponent({
  components: {
    Modal,
  },
  props: {
    show: {
      default: false,
    },
    maxWidth: {
      default: "2xl",
    },
    closeable: {
      default: true,
    },
  },
  emits: ["shown", "close"],
  setup(props, { emit, slots }) {
    const close = () => {
      emit("close");
    };

    const shown = () => {
      emit("shown");
    };

    const hasFooterContent = () => {
      return !!slots.footer;
    };

    return {
      shown,
      close,
      hasFooterContent
    };
  },
});
